
const digest = '4363620dc7006ba84b24205f5a73b3df66b98283569b57c1e97d17502e728dc9';
const classes = {"wrapper":"_wrapper_8bqbu_1","unseen":"_unseen_8bqbu_8","date":"_date_8bqbu_21","title":"_title_8bqbu_26","text":"_text_8bqbu_32","image":"_image_8bqbu_36"};
const css = `._wrapper_8bqbu_1 {
  padding: 20px;
  background-color: #fff;
  position: relative;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}
._wrapper_8bqbu_1._unseen_8bqbu_8 {
  background-color: #fff;
}
._wrapper_8bqbu_1._unseen_8bqbu_8:before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #619612;
  position: absolute;
  right: 20px;
  top: 20px;
}
._wrapper_8bqbu_1 ._date_8bqbu_21 {
  color: #000;
  font-size: 12px;
  margin-bottom: 3px;
}
._wrapper_8bqbu_1 ._title_8bqbu_26 {
  color: #1d65d8;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 3px;
}
._wrapper_8bqbu_1 ._text_8bqbu_32 {
  color: #000;
  font-size: 14px;
}
._wrapper_8bqbu_1 ._image_8bqbu_36 {
  position: relative;
  height: 260px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 15px;
  width: 100%;
  margin-bottom: 0.5rem;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  